module.exports = __webpack_public_path__ + "img/share-tip2.b3563566.png";